/**
 * Environment-derived config for Book4.
 * Supports Next.js (NEXT_PUBLIC_*) and Expo (EXPO_PUBLIC_*) env vars.
 */

const DEFAULT_API_BASE_URL = "http://localhost:4000";

/**
 * Get API base URL (origin only, no trailing slash or /api).
 * Reads NEXT_PUBLIC_API_URL (web) or EXPO_PUBLIC_API_URL (mobile).
 */
export function getApiBaseUrl(): string {
  const url =
    (typeof process !== "undefined" && process.env?.NEXT_PUBLIC_API_URL) ||
    (typeof process !== "undefined" && process.env?.EXPO_PUBLIC_API_URL) ||
    DEFAULT_API_BASE_URL;
  return url.replace(/\/$/, "").replace(/\/api$/i, "");
}
